module.exports = "<div class=ui-select-header ng-transclude></div> ";